import React, { createContext, useContext, useEffect, useState } from "react";
import { me, clearToken, getToken } from "../api";

const StudioCtx = createContext(null);
export const useStudio = () => useContext(StudioCtx);

export function StudioProvider({ children }) {
  const [user, setUser] = useState(undefined);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      if (!getToken()) { setUser(null); setReady(true); return; }
      try { setUser(await me()); }
      catch { clearToken(); setUser(null); }
      finally { setReady(true); }
    })();
  }, []);

  const logout = () => { clearToken(); setUser(null); };
  return <StudioCtx.Provider value={{ user, setUser, ready, logout }}>{children}</StudioCtx.Provider>;
}
